import React, { useEffect } from "react";
import ServiceHero from "../../Components/ServicePageComponents/ServiceHero";
import CommonContact from "../../Components/ContactPageComponents/CommonContact";
import providedservies1 from "../../Components/images/providedVideo-img1.png";
import providedservies2 from "../../Components/images/providedVideo-img2.png";
import providedservies3 from "../../Components/images/providedVideo-img3.png";
import ProvidedServicesM2 from "../../Components/ServicePageComponents/ProvidedServicesM2";
import Process from "../../Components/ServicePageComponents/Process";
import img1 from "./images/note.png"
import img2 from "./images/cpu-setting.png"
import img3 from "./images/search-status.png"

export default function VideoMarketing() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the component is mounted
  }, []);
  const processes = [
    {
      img: img1,
      title: "Content Planning and Creation",
    },
    {
      img: img2,
      title: "Optimization and Integration",
    },
    {
      img: img3,
      title: "Promotion and Analytics",
    },
  ];
  return (
    <div className="flex flex-col w-full bg-gradient-to-r from-[#121212] to-[#10204d]">
      <ServiceHero
        title={
          "Our engaging video marketing solutions can transform your brand and boost your business!"
        }
        para={
          "Video marketing allows businesses to showcase products, services, or stories in a dynamic and engaging way. It enhances customer interaction, boosts brand visibility, and improves search engine rankings."
        }
      />
      {/* pass a process as props */}
      <Process processes={processes}/>
      <ProvidedServicesM2
        title={"Video Content Creation and Production"}
        des={
          "Video content creation and production involve several key steps. It begins with brainstorming and scripting to define your message, followed by pre-production planning, where you organize shots and gather your team and equipment. During filming, focus on lighting and sound quality, while post-production is where you edit footage, add effects."
        }
        imageSrc={providedservies1}
        mobileimage={providedservies1}
        w={'445px'}
        h={'519px'}
        reverse={false}
      />
      <ProvidedServicesM2
        title={"Video Marketing Strategies"}
        des={
          "Video marketing strategies include YouTube channel management, social media campaigns, and influencer collaborations. YouTube management involves optimizing content with consistent branding, eye-catching thumbnails, and regular high-quality uploads to grow your audience. Social media video campaigns focus on short."
        }
        imageSrc={providedservies2}
        mobileimage={providedservies2}
        w={'535px'}
        h={'619px'}
        reverse={true}
      />
      <ProvidedServicesM2
        title={"Video SEO and Optimization"}
        des={
          "Video SEO and optimization encompass several key components, including effective strategies for paid video ads and distribution. Video SEO involves optimizing titles, descriptions, and tags to enhance visibility on search engines and video platforms, attracting organic traffic. Paid video ads on platforms like YouTube, Facebook, and Instagram can boost brand awareness ."
        }
        imageSrc={providedservies3}
        mobileimage={providedservies3}
        w={'535px'}
        h={'619px'}
        reverse={false}
      />
      <CommonContact />
    </div>
  );
}
